import { Button, Stack } from '@mui/material'
import './button.scss';
import IButtonData from '../../interfaces/button.interface';

export const MuiButton = ({ buttonData,buttonClick }: {buttonData:IButtonData, buttonClick:() => void}) => {
    return (
        <Stack display='block' spacing={2} direction='row'>
            <Button
                key={buttonData.id}
                variant={buttonData.variant}
                color={buttonData.color}
                size={buttonData.size}
                onClick={() => buttonClick()}
            >
                {buttonData.textButton}
            </Button>
        </Stack>
    )
}